module.exports = "\r\n<app-master></app-master>\r\n<!--<template ngbModalContainer>\r\n</template>-->\r\n\r\n"